// src/utils/fiRegion.js
export const MAAKUNNAT = [
  "Uusimaa","Varsinais-Suomi","Satakunta","Kanta-Häme","Pirkanmaa",
  "Päijät-Häme","Kymenlaakso","Etelä-Karjala","Etelä-Savo","Pohjois-Savo",
  "Pohjois-Karjala","Keski-Suomi","Etelä-Pohjanmaa","Pohjanmaa","Keski-Pohjanmaa",
  "Pohjois-Pohjanmaa","Kainuu","Lappi","Ahvenanmaa"
];

// Suomi-slug: ääkköset → ascii, välit/erikoismerkit → "-"
export function fiSlug(s) {
  return String(s || "")
    .toLowerCase()
    .replace(/å/g, "a").replace(/ä/g, "a").replace(/ö/g, "o")
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}

export function findNameBySlug(slug) {
  const target = String(slug || "").toLowerCase();
  return MAAKUNNAT.find((n) => fiSlug(n) === target) || null;
}

// "uusimaa,pohjois-pohjanmaa" → ["Uusimaa","Pohjois-Pohjanmaa"]
export function slugParamToNames(param) {
  if (!param) return [];
  return String(param)
    .split(",")
    .map((s) => s.trim())
    .map(findNameBySlug)
    .filter(Boolean);
}

// ["Uusimaa","Pohjois-Pohjanmaa"] → ["uusimaa","pohjois-pohjanmaa"]
export function namesToSlugList(names = []) {
  const uniq = Array.from(new Set(names.map((n) => String(n).trim()).filter(Boolean)));
  return uniq.map(fiSlug);
}
